import { useNavigate, useSearch } from "@tanstack/react-router"
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { DocumentsListPage } from "@/pages/admin/DocumentsListPage"
import { QuizzesListPage } from "@/pages/admin/QuizzesListPage"

// Documents and assessments under one destination, each as a tab, replacing
// the separate Assessments entry in the top bar.
//
// A page-level strip rather than another value on the documents page's own
// type filter: that filter drives the document query, the create dialog and
// which columns show, so an "assessments" value would have leaked into all
// three. Each tab keeps its own page, heading and filters, untouched.
//
// The tab lives in the URL so the assessment editor's back button can return
// to the Assessments tab rather than the default.
export function AdminContentPage() {
  const { tab = "documents" } = useSearch({ strict: false }) as {
    tab?: "documents" | "assessments"
  }
  const navigate = useNavigate()

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="container mx-auto shrink-0 pt-6">
        <Tabs
          value={tab}
          onValueChange={(value) =>
            navigate({
              to: "/admin/content",
              search: { tab: value as "documents" | "assessments" },
              replace: true,
            })
          }
        >
          <TabsList>
            <TabsTrigger value="documents">Documents</TabsTrigger>
            <TabsTrigger value="assessments">Assessments</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
      <div className="min-h-0 flex-1">
        {tab === "documents" ? <DocumentsListPage /> : <QuizzesListPage />}
      </div>
    </div>
  )
}
